import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';

import { TableDropdownFilter, TruncatedTextWithTooltip } from '@/components';
import { TableData } from '@/components/Table/types';
import { ContainerInfo } from '../../types';

export const getTableColumns = (
  data: ContainerInfo[] | undefined
): ColumnProps[] => {
  return [
    {
      field: 'stowage',
      header: 'Stowage',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'booking',
      header: 'Booking',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'contenedor',
      header: 'Contenedor',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      style: { fontWeight: 'bold' },
    },
    {
      field: 'armador',
      header: 'Armador',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="armador"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'iso',
      header: 'Iso',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="iso"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tipo',
      header: 'Ti',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tipo"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tamano',
      header: 'Ta',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tamano"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'destino1',
      header: 'Destino',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'nombreDestino',
      header: 'Nombre destino',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'statusOut',
      header: 'Sts',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="statusOut"
        />
      ),
    },
    {
      field: 'toneladas',
      header: 'GW',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'imos',
      header: 'Imos',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'uns',
      header: 'UN',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'temperatura',
      header: 'Temp.',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) =>
        rowData.temperatura !== null ? `${rowData.temperatura} °C` : '',
    },
    {
      field: 'ventilacion',
      header: 'Vent',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto1',
      header: 'Precinto 1',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto2',
      header: 'Precinto 2',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto3',
      header: 'Precinto 3',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto4',
      header: 'Precinto 4',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'mercaderia',
      header: 'Mercadería',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData: ContainerInfo) =>
        rowData.mercaderia.length > 30 ? (
          <TruncatedTextWithTooltip text={rowData.mercaderia} maxLength={30} />
        ) : (
          rowData.mercaderia
        ),
    },
    {
      field: 'destinoFinal',
      header: 'Destino final',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
  ];
};
